import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Box } from '../Box/Box.js';
import { Icon } from '../Icon/Icon.js';
import { TextLink } from '../TextLink/TextLink.js';
import { Typography } from '../Typography/Typography.js';

var _excluded = ["label", "onClick", "url", "target"];
var iconElement = function iconElement(asset, color) {
  return asset && /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "start",
    pe: "8"
  }, /*#__PURE__*/React.createElement(Icon, {
    id: asset,
    color: color,
    size: "20"
  }));
};
var titleElement = function titleElement(title, description, hasIcon) {
  return title && /*#__PURE__*/React.createElement(Typography, {
    variant: "body-s-strong",
    pb: description ? '4' : '0',
    me: hasIcon ? '24' : '16'
  }, title);
};
var descriptionElement = function descriptionElement(description) {
  return description && /*#__PURE__*/React.createElement(Typography, {
    variant: "body-s"
  }, description);
};
var actionElement = function actionElement(action) {
  if (!action) return null;
  var label = action.label,
    onClick = action.onClick,
    url = action.url,
    target = action.target,
    attributes = _objectWithoutProperties(action, _excluded);
  return /*#__PURE__*/React.createElement(Box, {
    key: label,
    display: "flex",
    pt: "8"
  }, /*#__PURE__*/React.createElement(TextLink, _extends({
    onClick: onClick,
    hierarchy: "primary",
    textVariant: "body-s",
    label: label,
    href: url,
    target: target
  }, attributes)));
};

export { actionElement, descriptionElement, iconElement, titleElement };
//# sourceMappingURL=BaseNotification.js.map
